import { render, staticRenderFns } from "./OperShif.vue?vue&type=template&id=9a525c24&scoped=true"
import script from "./OperShif.vue?vue&type=script&lang=js"
export * from "./OperShif.vue?vue&type=script&lang=js"
import style0 from "./OperShif.vue?vue&type=style&index=0&id=9a525c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a525c24",
  null
  
)

export default component.exports